import { ReactComponent as AchievementIcon } from '../../../../assets/icons/timeline/greenAchievementIcon.svg';
import { map } from 'lodash';
import useEventList from './useEventList';
import { eventType } from '../NewEventModal';

export default function useAchievementEvent(patientUuid: string) {
  const achievementList = useEventList(patientUuid, ['achievement']);

  return map(
    achievementList ?? [],
    ({ eventTimestamp, therapistComment, uuid, affectedSide }) => ({
      name: 'Achievement',
      date: eventTimestamp,
      icon: AchievementIcon,
      description: therapistComment ?? '',
      id: uuid,
      tabName: eventType.achievement,
      affectedSide
    })
  );
}
